import React from "react";
import { FC } from "react";
import { ISchool } from "../../../../school/types";

const SchoolProfileShow: FC<{ school: ISchool }> = ({ school }) => {
  return <>{school.name}</>;
};

export default React.memo(SchoolProfileShow);
